import { assert } from '../../lib/assert-sidecar'
import { rando } from '../../lib/rando-sidecar'
import { common } from '../../main/common-sidecar'
import { EVoyageCrewCarryCommand } from './multi/voyageMessageCrewCarry'
import { voyageMessageCrewCarry } from './multi/voyageMessageCrewCarry-sidecar'
import { EVoyageCrewDamageType } from './multi/voyageMessageCrewHurt'
import { voyageMessageCrewHurt } from './multi/voyageMessageCrewHurt-sidecar'
import { EVoyageCarryableType } from './voyageCarryableData'
import type { IVoyageCrew } from './voyageCrew'
import { voyageCrew_movable } from './voyageCrew_movable-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'
import { voyageWebsockets } from './voyageWebsockets-sidecar'

export interface IVoyageCrewAlien {
  // fireExtinguishTimer: number
  // useSystemTimer: number
  isAiInitiated: boolean
  aiType: EAlienAi
}

export enum EAlienAi {
  Guard = 1,
  Goto = 2,
  Bomb = 3,
}

export function create() {
  let d: IVoyageCrewAlien = {
    // fireExtinguishTimer: 0,
    // useSystemTimer: 0,
    isAiInitiated: false,
    // aiType: EAlienAi.Bomb,
    aiType: rando.sample([EAlienAi.Guard, EAlienAi.Bomb, EAlienAi.Goto]),
  }
  return d
}

export function update(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.alienState
  assert.notNil(d)

  if (obj.isDead) {
    return
  }
  if (obj.isDying) {
    return
  }

  voyageGameStatus.get().hasBoarders.willBeActive = true

  if (!d.isAiInitiated) {
    if (voyageWebsockets.getIsHost()) {
      if (d.aiType === EAlienAi.Guard) {
        d.isAiInitiated = true
      }
      if (d.aiType === EAlienAi.Goto) {
        let f = voyageTilemap.getRandomFloor()
        if (voyageCrew_movable.pathTo(obj, f.i, f.j)) {
          d.isAiInitiated = true
        }
      }

      if (d.aiType === EAlienAi.Bomb) {
        if (obj.items.length === 0) {
          voyageMessageCrewCarry.sendCreateMessageAndImmediatelyExecute({
            type: rando.sample([
              EVoyageCarryableType.Breachbomb,
              EVoyageCarryableType.Firebomb,
            ]),
            i: obj.i,
            j: obj.j,
            crewId: obj.id,
          })
        }

        let f = voyageTilemap.getRandomFloor()
        if (voyageCrew_movable.pathTo(obj, f.i, f.j)) {
          d.isAiInitiated = true
        }
      }
    }
  } else {
    if (d.aiType === EAlienAi.Bomb) {
      if (!obj.path && obj.items.length > 0) {
        voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
          command: EVoyageCrewCarryCommand.Drop,
          carryId1: obj.items[0].id,
          carryId2: 0,
          crewId: obj.id,
          i: obj.i,
          j: obj.j,
          type: obj.items[0].type,
        })
      }
    }

    if (obj.items.length === 0) {
      voyageMessageCrewHurt.sendMessageAndImmediatelyExecute({
        crewId: obj.id,
        byCrewId: 0,
        newHitpoints: 0,
        type: EVoyageCrewDamageType.Teleport,
      })
    }
  }
}
